import Registry from "./models/Registry";
import MainMenu from './components/MainMenu'; 
import './components/Fadein';
import GMap from './components/GMap.js';

class App {
  constructor(context) {
    this.registry = new Registry();
    this.registerComponents(); 
    this.initController(context);
    this.patchIos();
    this.setvh();
		this.placeholderNewsletter();
  }

  initController(contextData) {
    const ContextClass = this.registry.getContext(contextData);
    new ContextClass(contextData);
  }

  registerComponents() {
    this.registry
      // ---- Componenti Caricati Staticamente ----
      // Registriamo direttamente la classe importata
      .addComponent('MainMenu', MainMenu)

      // ---- Componenti Caricati Dinamicamente ----
      // Registriamo una FUNZIONE che esegue l'import dinamico
      .addComponent('Slider', () => import("./components/Slider"))
      .addComponent('Accordion', () => import("./components/Accordion"))
      .addComponent('VimeoEmbed', () => import("./components/VimeoEmbed"))
      .addComponent('Modal', () => import("./components/Modal"))
      .addComponent('Filters', () => import("./components/Filters"))
      .addComponent('FiltersProdotti', () => import("./components/FiltersProdotti"))
      .addComponent('VideoPlayer', () => import("./components/VideoPlayer"))
      .addComponent('SliderHero', () => import("./components/SliderHero"))
      .addComponent('BorderAnimation', () => import("./components/BorderAnimation"))
      .addComponent('SliderResources', () => import("./components/SliderResources"))
      .addComponent('SliderProd', () => import("./components/SliderProd"))
      .addComponent('FilterAccordion', () => import("./components/FilterAccordion"))
      .addComponent('ViewSwitcher', () => import("./components/SwitcherViewProduct"))
      .addComponent('SliderStoria', () => import("./components/SliderStoria"))
			.addComponent('GMap',GMap)
      .addComponent('InjectIconArrow', () => import("./components/InjectIconArrow"))
      .addComponent('ImageAnimation', () => import("./components/ImageAnimation"))
			.addComponent('TitleAnimation', () => import("./components/TitleAnimation"))
    ;
  }

  patchIos() {
    window.addEventListener('resize', () => this.appHeight());
    this.appHeight();
  }

  appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  }

  setvh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

	placeholderNewsletter() {
		// Aggiungo il placeholder al form di Mailup
		const emailInput = document.querySelector('#mupwp-form-fields input[type="email"]');
		if (emailInput) {
			emailInput.placeholder = '@Enter your email';
		}
	}

}

window.AppInit = function(context) {
    new App(context);
};
